<div
  class="arrow {{ showArrow ? '' : 'd-none' }}"
  (click)="scrollTop()"
  (scroll)="checkScroll()"
>
  <span class="iconify" data-icon="fontisto:angle-up"></span>
</div>
